import localforage from "localforage"
import {ElMessage} from "element-plus"
import {store} from "@/store"

export default {
  async clear(callback, drop = false) {
    if (drop) {
      await this.dropFormsDataStore()
      await this.dropMainStore()
      await this.dropMainDatabase()
    } else {
      await this.clearMainStore()
      await this.clearFormsDataStore()
    }
    if (callback) callback()
  },
  // clear
  async clearMainStore() {
    let notification = this.setNofication()
    try {
      await localforage.clear()
    } catch (e) {
    }
    this.unsetNofication(notification)
  },
  async clearFormsDataStore() {
    let notification = this.setNofication()
    try {
      await store.dispatch("Forms/actionClear")
    } catch (e) {
    }
    this.unsetNofication(notification)
  },
  // drop blocks because of duplicate tabs
  async dropMainStore() {
    let notification = this.setNofication()
    try {
      await localforage.dropInstance({storeName: "keyvaluepairs"})
    } catch (e) {
    }
    this.unsetNofication(notification)
  },
  async dropFormsDataStore() {
    let notification = this.setNofication()
    try {
      await localforage.dropInstance({storeName: "formsData"})
    } catch (e) {
    }
    this.unsetNofication(notification)
  },
  async dropMainDatabase() {
    let notification = this.setNofication()
    try {
      await localforage.dropInstance({name: "localforage"})
    } catch (e) {
    }
    this.unsetNofication(notification)
  },
  setNofication() {
    let notification = setTimeout(function () {
      ElMessage({
        message: "Закройте страницы этого сайта в других вкладках и обновите страницу",
        type: "warning",
        duration: 0,
        showClose: true,
      });
    }, 30000)
    return notification
  },
  unsetNofication(notification) {
    clearTimeout(notification)
    notification = undefined
  },
}
